import { render, staticRenderFns } from "./AllActiveJobsTable.vue?vue&type=template&id=70b63da0&scoped=true&"
import script from "./AllActiveJobsTable.vue?vue&type=script&lang=js&"
export * from "./AllActiveJobsTable.vue?vue&type=script&lang=js&"
import style0 from "./AllActiveJobsTable.vue?vue&type=style&index=0&id=70b63da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b63da0",
  null
  
)

export default component.exports